export const EXAM_SEASONS = {
  if_2122: {
    season_name: "if_2122", // intellisense için
    exam_ids: {
      1: ["if2022_sinif_3_xG5M3I5hBVO0RQPPoRsM", "tzvif3wlvShrn56g94I4WMT3tM"],
      2: ["if2022_sinif_3_xG5M3I5hBVO0RQPPoRsM", "tzvif3wlvShrn56g94I4WMT3tM"],
      3: ["if2022_sinif_3_xG5M3I5hBVO0RQPPoRsM", "tzvif3wlvShrn56g94I4WMT3tM"],
      4: ["if2022_sinif_4_mqVDCReKn4rngPxOjH5O", "tzvif45z81290jmLFdgzCpqsuP"],
      5: ["if2022_sinif_5_EG9PnOLmsBTqx0svBhnK", "tzvif5M4NDPudbeTxIZ7HkJE26"],
      6: ["if2022_sinif_6_hnFVSI7Xn25w9aDCCbAy", "tzvif6pxOEI2BAm8iWNsIIhpJ2"],
      7: ["if2022_sinif_7_FBG04GFN1pdiF67BKALr", "tzvif7yJvjql8U5SvqzspeuNCS"],
      8: ["if2022_sinif_8_AUbD4HbANQu6E7BcUFVJ", "tzvif8lNDWcAtaWJj2ycSIB7ru"],
      9: ["if2022_sinif_9_M0Y3kySdUYK947jSij0h", "tzvif9zD0NPkVMaGRUT8OEKkXB"],
      10: [
        "if2022_sinif_10_oOkXkvGgW5sploMQWKdR",
        "tzvif10EIXUUM7HvTmWYakb1qmM",
      ],
      11: [
        "if2022_sinif_11_UZZU3uwAKlbEovcQUzsU",
        "tzvif11zFDHcELCVnUApU5HNSQv",
      ],
      12: [
        "if2022_sinif_12_khiU0y5b66iNaz1cDGW4",
        "tzvif12wFZeOjjs5lTOirYQH2Gf",
      ],
    },
  },

  bf_2122: {
    season_name: "bf_2122", // intellisense için
    exam_ids: {
      1: ["bf2022_sinif_3_oLvJb9OzpUdeKnKi8SqM", "tzvbf3WuTlD5qWk2yHZsqDodPh"],
      2: ["bf2022_sinif_3_oLvJb9OzpUdeKnKi8SqM", "tzvbf3WuTlD5qWk2yHZsqDodPh"],
      3: ["bf2022_sinif_3_oLvJb9OzpUdeKnKi8SqM", "tzvbf3WuTlD5qWk2yHZsqDodPh"],
      4: ["bf2022_sinif_4_gBabGafqhDmWl39w0ySL", "tzvbf4R7zcLzXKgS5O76BXAGwL"],
      5: ["bf2022_sinif_5_XyMxsRbcMkq1xw5TaDJl", "tzvbf5L4adju6Aljq6TI9WXJ9N"],
      6: ["bf2022_sinif_6_Epp2v1vBFZHSkuCQel3g", "tzvbf68azYY0UksPfN0JESkgFU"],
      7: ["bf2022_sinif_7_hIXOIIOsdCCJ2nIsbY9s", "tzvbf7K5sv4nRkssRzrPzEBech"],
      8: ["bf2022_sinif_8_phslrVVyauH1a6uP2G0y", "tzvbf8BWvn4SSEeMQ79BRQjlSH"],
      9: ["bf2022_sinif_9_EiernFEL4WxT2kCgreVq", "tzvbf9EDrzhyO14XQ489p0FD0Y"],
      10: [
        "bf2022_sinif_10_k02EQlNCrwpdHh37PI3H",
        "tzvbf10jM2Za3pn9SaEG24KO6bh",
      ],
      11: [
        "bf2022_sinif_11_5417r1T14vatdJfM98To",
        "tzvbf11ExEUjfYQGeyhd7il7d4c",
      ],
      12: [
        "bf2022_sinif_12_bwA4vxQQ0oKd6qe7AhBe",
        "tzvbf12iLpWKrlWybekZzwtNl1u",
      ],
    },
  },

  tf_2122: {
    season_name: "tf_2122", // intellisense için
    exam_ids: {
      1: [
        "tf2022_sinif_3_1wyNnkdGuX8VglfX7vC2",
        "tf2022_sinif_3_questions_HXuxFQYK2DXk6VG2wvWf",
      ],
      2: [
        "tf2022_sinif_3_1wyNnkdGuX8VglfX7vC2",
        "tf2022_sinif_3_questions_HXuxFQYK2DXk6VG2wvWf",
      ],
      3: [
        "tf2022_sinif_3_1wyNnkdGuX8VglfX7vC2",
        "tf2022_sinif_3_questions_HXuxFQYK2DXk6VG2wvWf",
      ],
      4: [
        "tf2022_sinif_4_3Lzi2sVr8INIzRKrLhjr",
        "tf2022_sinif_4_questions_CAUOCdF5ocOSNkdjBxfv",
      ],
      5: [
        "tf2022_sinif_5_41NdpPwlVYu3hgvfg2pT",
        "tf2022_sinif_5_questions_RLnmbSWTVTLQOXg0wqmJ",
      ],
      6: [
        "tf2022_sinif_6_6kuJUctEvbocMBO9QxFl",
        "tf2022_sinif_6_questions_nWT842U0GLQZB4olf3sm",
      ],
      7: [
        "tf2022_sinif_7_LMQHNEIiQrexdktXdMXM",
        "tf2022_sinif_7_questions_Qr7Aos9W8cekl2lhgWZV",
      ],
      8: [
        "tf2022_sinif_8_NqbeJgbJMjxhWAQJP3sC",
        "tf2022_sinif_8_questions_2e9WmQAOkIz6RE4d3s81",
      ],
      9: [
        "tf2022_sinif_9_csSp4KkfRUhtWEYJ8h9i",
        "tf2022_sinif_9_questions_F9Gsj3g9UAlkWgnZKGMo",
      ],
      10: [
        "tf2022_sinif_10_knTvPXGOhCutkynfZz2z",
        "tf2022_sinif_10_questions_v6Zjs8UzmnPyO3oBj0aE",
      ],
      11: [
        "tf2022_sinif_11_mPH03pNaDsa4G46JoODD",
        "tf2022_sinif_11_questions_PexcpbiLe1v98iOh9SCr",
      ],
      12: [
        "tf2022_sinif_12_piG1TtvXHkkotzyY00qG",
        "tf2022_sinif_12_questions_R6b5FBcWhKnk2FQvYhpV",
      ],
    },
  },

  if_2223: {
    season_name: "if_2223",
    exam_ids: {
      1: [
        "if2023_sinif_1_TqIpXBnJ7Ge6rrK9j9y1",
        "if2023_sinif_1_eq_CI3FTjzd1YQsWmuXICV1",
      ],
      2: [
        "if2023_sinif_2_JtCrSwyaKI4t3RBL1sjX",
        "if2023_sinif_2_eq_dNw1Rs5QqHEuj4zRHsoL",
      ],
      3: [
        "if2023_sinif_3_br3gGEX1kFG6q03fk7oj",
        "if2023_sinif_3_eq_Ne4IVnekA91XWGGqxpIj",
      ],
      4: [
        "if2023_sinif_4_MZfJhMDVIATzcwxLMvaz",
        "if2023_sinif_4_eq_rVH0XuSRsE58lgSWW5NK",
      ],
      5: [
        "if2023_sinif_5_X34cAwvqUmrJh6Ro1amv",
        "if2023_sinif_5_eq_rztv27Ylx1NWdqPIwjlv",
      ],
      6: [
        "if2023_sinif_6_uZ3be60SKimADnPyBMPy",
        "if2023_sinif_6_eq_kgyG2ubflISfbqqteAKY",
      ],
      7: [
        "if2023_sinif_7_yrplFfAemqSz6HL5rXZf",
        "if2023_sinif_7_eq_nYlZN8PUee5u5dZYtYuq",
      ],
      8: [
        "if2023_sinif_8_bLC5sZ5moDaPguskLiny",
        "if2023_sinif_8_eq_0PEVoL9pqNNHUVe2Jhtu",
      ],
      9: [
        "if2023_sinif_9_pI4Y3OJjgPIjQXbo3Zx8",
        "if2023_sinif_9_eq_j7FiISXE50LY59CQlzb5",
      ],
      10: [
        "if2023_sinif_10_zj8HkZZLeKsdnBabIq7P",
        "if2023_sinif_10_eq_N8uvSe8Yz5B06LN56dg1",
      ],
      11: [
        "if2023_sinif_11_2ZuQIHhWtZnet0SdfYlv",
        "if2023_sinif_11_eq_GccRBqYzyac7Zdu4WHTV",
      ],
      12: [
        "if2023_sinif_12_jSH4p8neXAomQLomiyip",
        "if2023_sinif_12_eq_rZa6zZ96WKof9VThD9Pi",
      ],
    },
  },

  bf_2223: {
    season_name: "bf_2223", // intellisense için
    exam_ids: {
      1: [
        "bf2023_sinif_1_azr8o81GO1PHo1hsdy4L",
        "bf2023_sinif_1_eq_slwyllTwaVJVZDBNjmL2",
      ],
      2: [
        "bf2023_sinif_2_s6bifxLXBpKSf4QzOhgk",
        "bf2023_sinif_2_eq_jvFnO58OYkl0retydbIC",
      ],
      3: [
        "bf2023_sinif_3_5ZqPsEcyGIPWNHbxzECo",
        "bf2023_sinif_3_eq_QpFkjPSpFOkABdvk2C5h",
      ],
      4: [
        "bf2023_sinif_4_OmQOkoh4EpwJp4OunMMK",
        "bf2023_sinif_4_eq_m3wbdlasrxAA6rvyM6Zs",
      ],
      5: [
        "bf2023_sinif_5_GhjJCAQAeKV8R46aQQ0p",
        "bf2023_sinif_5_eq_jZRjgu0NUdF0qIkDJ0vs",
      ],
      6: [
        "bf2023_sinif_6_5xt0prF6R3wOSCa8sp99",
        "bf2023_sinif_6_eq_hIFhhc15zE4rUXdsKphH",
      ],
      7: [
        "bf2023_sinif_7_cSq77TPqTS9UQcGtRGwL",
        "bf2023_sinif_7_eq_n1of7t8HtP46YEvAL7Uq",
      ],
      8: [
        "bf2023_sinif_8_dPCLXKopjxDcYrovQCia",
        "bf2023_sinif_8_eq_s5ZHwKelbeApyhsVXoac",
      ],
      9: [
        "bf2023_sinif_9_knqacAbBtWjiCgQ516TP",
        "bf2023_sinif_9_eq_cHxcCd1t1UzwCK5MqoWf",
      ],
      10: [
        "bf2023_sinif_10_0IwuxgPAm94UMc1kxKs5",
        "bf2023_sinif_10_eq_gSAGzNG3olq7VPZpauks",
      ],
      11: [
        "bf2023_sinif_11_Ya9gK9iwb6v8Xm6mjfqB",
        "bf2023_sinif_11_eq_PMF6S1rmGxPZarnt72Gx",
      ],
      12: [
        "bf2023_sinif_12_8KR0gNUoXjjdtfOblfLq",
        "bf2023_sinif_12_eq_7mvrfeOmmtdQjmljxXbK",
      ],
    },
  },

  dnm_2024: {
    season_name: "dnm_2024",
    exam_ids: {
      1: [
        "dnm2024_sinif_1_HCW3NpxP9ehhIbOiM53i",
        "dnm2024_sinif_1_eq_JPak4OSjEe4jrO8tsPd0",
      ],
      2: [
        "dnm2024_sinif_2_3F51iWSyclvX8vSCynNj",
        "dnm2024_sinif_2_eq_rZcWKy2NPvTaZs42NxRr",
      ],
      3: [
        "dnm2024_sinif_3_wup8T5CpQ3S72UvjIOD4",
        "dnm2024_sinif_3_eq_xypbUIKTBH55yBt6incD",
      ],
      4: [
        "dnm2024_sinif_4_YexTGssteH1EuBStC8oi",
        "dnm2024_sinif_4_eq_SQqspJt5D1X5UCKRq08H",
      ],
      5: [
        "dnm2024_sinif_5_x8JnRbGBkWw1dwwlJRGo",
        "dnm2024_sinif_5_eq_aJvxDCa4CMLJA6hAPEk3",
      ],
      6: [
        "dnm2024_sinif_6_cF0UBBcAelBfhPE66Xnm",
        "dnm2024_sinif_6_eq_u5hKqPkRhyPWp2LzLwyX",
      ],
      7: [
        "dnm2024_sinif_7_eFwLVXFEDgPl1t8Hs7mU",
        "dnm2024_sinif_7_eq_Yh5kSGiHCbw12KhJuP7f",
      ],
      8: [
        "dnm2024_sinif_8_rHE8Bvj9hbmypQcXBuyX",
        "dnm2024_sinif_8_eq_YuU7QGO2z1mjkbqCTocW",
      ],
      9: [
        "dnm2024_sinif_9_w0h0LgOqesikrJtdeapG",
        "dnm2024_sinif_9_eq_3DK1dJGyT0UUEKmW9lKi",
      ],
      10: [
        "dnm2024_sinif_10_stVcs9vd4QxCWgIs638g",
        "dnm2024_sinif_10_eq_uvB43lHxO2OO72cnGJJn",
      ],
      11: [
        "dnm2024_sinif_11_8ROPtFbTdTUrEOJquT7y",
        "dnm2024_sinif_11_eq_ZDputsgkbO6C3eL2uupF",
      ],
      12: [
        "dnm2024_sinif_12_Ss8V7sMHSLhWXob2Ts6z",
        "dnm2024_sinif_12_eq_sQq0EU8OLcOtC9v9NW5V",
      ],
    },
  },

  if_2324: {
    season_name: "if_2324",
    exam_ids: {
      1: [
        "if2024_sinif_1_qYvPcb68hvB5170bXzN3",
        "if2024_sinif_1_eq_cMN5w718AbIyxs0Q7Qoi",
      ],
      2: [
        "if2024_sinif_2_XeSSe2IfOFAhtBbhiBmF",
        "if2024_sinif_2_eq_HDfWjHruOHBlV7mTA1af",
      ],
      3: [
        "if2024_sinif_3_63jYwvCts3TqM484IFoJ",
        "if2024_sinif_3_eq_5EQZgHI94F8Mz2PsmVc1",
      ],
      4: [
        "if2024_sinif_4_3FtlLjqQz82uRITewryH",
        "if2024_sinif_4_eq_JW53DytDJo9vmLDfSacF",
      ],
      5: [
        "if2024_sinif_5_k62pi3OFTwDTFbMhgY5Y",
        "if2024_sinif_5_eq_N0MdA0xIqVBQvZ3Ir0lM",
      ],
      6: [
        "if2024_sinif_6_k4zwxsC88bADUkiU6Lov",
        "if2024_sinif_6_eq_QEdCWX9sP45ZTwfHqe0b",
      ],
      7: [
        "if2024_sinif_7_0BHWiIUTYo08PQBdmZWv",
        "if2024_sinif_7_eq_pVsbqXFmFyG3oQwAY6XB",
      ],
      8: [
        "if2024_sinif_8_kC66v4Xu7ZKMneYGhSq4",
        "if2024_sinif_8_eq_uHsNF6u6gLIe9LE5x4IC",
      ],
      9: [
        "if2024_sinif_9_0EExd0abQpxn7Wks7yaz",
        "if2024_sinif_9_eq_XIlVfZWPWgqJMApGSEgQ",
      ],
      10: [
        "if2024_sinif_10_eWbFldGuOv8LikQUwCeB",
        "if2024_sinif_10_eq_4DkQJF8rhNRAq6GFZVk0",
      ],
      11: [
        "if2024_sinif_11_XTIytVWjOFURQy0lqZEm",
        "if2024_sinif_11_eq_ZmSR455RRMJELWwA0hu6",
      ],
      12: [
        "if2024_sinif_12_wbMjwGSmsBrpWkBtBrfm",
        "if2024_sinif_12_eq_0cbYX942ZHhUjm6bCwV8",
      ],
    },
  },

  bf_2324: {
    season_name: "bf_2324",
    exam_ids: {
      1: [
        "bf2024_sinif_1_YCbnSYjrm8XQP92hTL1c",
        "bf2024_sinif_1_eq_iZxRQnoOOxoTa4i7kD5d",
      ],
      2: [
        "bf2024_sinif_2_eoeKOUokXRO8ISxxcqzj",
        "bf2024_sinif_2_eq_QuUrziWeCIi3LMfOvI7E",
      ],
      3: [
        "bf2024_sinif_3_wSFDtZN2ThGqtn63AAMs",
        "bf2024_sinif_3_eq_dtUhMnmlQG8vkIivdL9y",
      ],
      4: [
        "bf2024_sinif_4_DXrEnfD15zClmH5uec4Q",
        "bf2024_sinif_4_eq_TZ5421GejWWi6y83yxi8",
      ],
      5: [
        "bf2024_sinif_5_bi3RNw79pXSKJi5rs0lp",
        "bf2024_sinif_5_eq_XRAZIU7IKnVFRdnPVcBV",
      ],
      6: [
        "bf2024_sinif_6_0FHdYIpUdN0s8fzSRG6Y",
        "bf2024_sinif_6_eq_BUIPhwjLlplc0Urr8kmC",
      ],
      7: [
        "bf2024_sinif_7_Oo62sxTd5m7ONdShUAvc",
        "bf2024_sinif_7_eq_J7POfTesJuNVhIyWWDeM",
      ],
      8: [
        "bf2024_sinif_8_HJWKCryomeqTrR0Fs4CM",
        "bf2024_sinif_8_eq_TKhCN0EySN2iUWhFVlA0",
      ],
      9: [
        "bf2024_sinif_9_Klv12CLv1UgoX2dQqgey",
        "bf2024_sinif_9_eq_ZOJfzsVYAdH5fiVBDU5q",
      ],
      10: [
        "bf2024_sinif_10_gOwGbtty8a7h3MAR4BZD",
        "bf2024_sinif_10_eq_okbgt5Nzdna1ryeHIknL",
      ],
      11: [
        "bf2024_sinif_11_JhfIJi1UDih9XjWiavIz",
        "bf2024_sinif_11_eq_nibTK65czq8EKsflKdGw",
      ],
      12: [
        "bf2024_sinif_12_EslKm3SejDrQS8BGMSql",
        "bf2024_sinif_12_eq_a6Bs0RdVZUcRYyAxPLuj",
      ],
    },
  },

  tb_2425: {
    season_name: "tb_2425",
    exam_ids: {
      1: [
        "tb2025_sinif_1_Szr8o91kO1lHP1hsdN4X",
        "tb2025_sinif_1_eq_PlwyjlRwawJVNDBNjnL6",
      ],
      2: [
        "tb2025_sinif_2_K4bijxLXdpKSf4Qz0hgP",
        "tb2025_sinif_2_eq_kvEn257OYkl0qetydbIQ",
      ],
      3: [
        "tb2025_sinif_3_2cqPsEZyeIPWNfbxzECS",
        "tb2025_sinif_3_eq_FpFkjMSpFOkaBdvD2C5s",
      ],
      4: [
        "tb2025_sinif_4_UmqOkoh4EpVJp4zuniMp",
        "tb2025_sinif_4_eq_N3QbdLasrxaB6rvym6ZX",
      ],
      5: [
        "tb2025_sinif_5_NhjiCAfAeKV7R26aQQ0h",
        "tb2025_sinif_5_eq_PZrjgujNRdFgqIkAJ0vV",
      ],
      6: [
        "tb2025_sinif_6_4CtHprF6R3wOsCa8sp63",
        "tb2025_sinif_6_eq_qIFHhc95zE2rUcdsKpiP",
      ],
      7: [
        "tb2025_sinif_7_WSq07TPqTS6UQcGtBGwN",
        "tb2025_sinif_7_eq_c1of2t9HtP4uYEvBL7U2",
      ],
      8: [
        "tb2025_sinif_8_BPdLXzopjxDcYroLQCiP",
        "tb2025_sinif_8_eq_24ZHwJelBeApyhSVcoaX",
      ],
      9: [
        "tb2025_sinif_9_JnWacAUBRWjiCgq013TP",
        "tb2025_sinif_9_eq_ZjxcCd1t1kzwCbK5mqoVH",
      ],
      10: [
        "tb2025_sinif_10_8IwuxDgAmw4UMk1klKs1",
        "tb2025_sinif_10_eq_gDAgzNG3OLq7VpZpaukE",
      ],
      11: [
        "tb2025_sinif_11_YA9GK2iJb6v8Xm6Njfqj",
        "tb2025_sinif_11_eq_vMf6S3rmQxPZarnt75qx",
      ],
      12: [
        "tb2025_sinif_12_4lW0gNUoXFjdRfOblfL5",
        "tb2025_sinif_12_eq_3mvrfeWMmtdqjmljxvbL",
      ],
    },
  },
  if_2425: {
    season_name: "if_2425",
    exam_ids: {
      1: [
        "if2025_sinif_1_Pzr8p9SkO1ljP1hsdm8z",
        "if2025_sinif_1_eq_clwyLlRwBQJVNsBNjmL7",
      ],
      2: [
        "if2025_sinif_2_q8AGjxlXdpKdf4Qz0hgÇ",
        "if2025_sinif_2_eq_KvEC27XOYkllqewydvIX",
      ],
      3: [
        "if2025_sinif_3_UcqwsEZYeIPqNfbxzbAa",
        "if2025_sinif_3_eq_JpDkFMSpFYkaBdvDxC9a",
      ],
      4: [
        "if2025_sinif_4_XDqOKoh6EpVJp8zunLMV",
        "if2025_sinif_4_eq_K3QXdLAsRxaB3rvLm6mC",
      ],
      5: [
        "if2025_sinif_5_MhliCbfArKV7R26awq0F",
        "if2025_sinif_5_eq_şZejgjxNRDFGqIkAJ2vW",
      ],
      6: [
        "if2025_sinif_6_vCtHPrF6q3wOsCa8sp69",
        "if2025_sinif_6_eq_FlFghx97zE2wUcDsKpLC",
      ],
      7: [
        "if2025_sinif_7_eaSq57TPqTg6UQbGtBqwv",
        "if2025_sinif_7_eq_V2osot4Hth4uzxvBş8is",
      ],
      8: [
        "if2025_sinif_8_cudLlzopKxDctroLQCiP",
        "if2025_sinif_8_eq_QwxHrJeKxeALyFSvcOaB",
      ],
      9: [
        "if2025_sinif_9_JVWacAUvRWjlCgq013ET",
        "if2025_sinif_9_eq_XjBcNd2t1kZwCBK5ÇqoXF",
      ],
      10: [
        "if2025_sinif_10_qIwuXDgbmw8UMk1HlKsh",
        "if2025_sinif_10_eq_FgafZNk7O8d7VpZpaUkc",
      ],
      11: [
        "if2025_sinif_11_zA6GK2iJb6y8Xn6Njfqf",
        "if2025_sinif_11_eq_Ynf8feRmQxCZaRnt78qL",
      ],
      12: [
        "if2025_sinif_12_hfW0gmUoXFddefObLfLş",
        "if2025_sinif_12_eq_E8vrLeQCmTdqjmljxFbŞ",
      ],
    },
  },

  bf_2425: {
    season_name: "bf_2425",
    exam_ids: {
      1: [
        "bf2025_sinif_1_lzr6p9dkO1OjP5hsdA8X",
        "bf2025_sinif_1_eq_uleyLlRwBqJVNsBNpm8f",
      ],
      2: [
        "bf2025_sinif_2_W8AqjxlcdeKkf4Qv0hgp",
        "bf2025_sinif_2_eq_hvECe7XoYkhlqeWydvY4",
      ],
      3: [
        "bf2025_sinif_3_lcewsvZYwIPgNfMxZbAq",
        "bf2025_sinif_3_eq_OpDuFMSpFekaBdxDxCqs",
      ],
      4: [
        "bf2025_sinif_4_CDqoKo76EpGJp8zuNLqB",
        "bf2025_sinif_4_eq_s3QXdLAsexaw3rbLw7mc",
      ],
      5: [
        "bf2025_sinif_5_nhleCbDArLV7RW7awL0S",
        "bf2025_sinif_5_eq_gZekgexNRvFGqekAJ8vc",
      ],
      6: [
        "bf2025_sinif_6_KLtpPrj6q3wRsha7sp87",
        "bf2025_sinif_6_eq_wlbghc97eE2WUcDsLpEX",
      ],
      7: [
        "bf2025_sinif_7_qxSq5eTYqfg6tQvGtBywv",
        "bf2025_sinif_7_eq_U2Ksot8Hth4uYxvbL8rE",
      ],
      8: [
        "bf2025_sinif_8_vulLUzopWxDXtEoLQCfl",
        "bf2025_sinif_8_eq_QYxhEJeKbeaLTFSncOAb",
      ],
      9: [
        "bf2025_sinif_9_kVewcAbvRrjlngq093tb",
        "bf2025_sinif_9_eq_crBcND2E1oZwxBh5dQoF6",
      ],
      10: [
        "bf2025_sinif_10_bIEuCDgbTw9Unk1glKsp",
        "bf2025_sinif_10_eq_EgBNZlk9Ody7EpZBaUBx",
      ],
      11: [
        "bf2025_sinif_11_Ap6GK2rJl6y9Xn8Nkfqe",
        "bf2025_sinif_11_eq_ynJ8MeEmqxbZaRkt58qp",
      ],
      12: [
        "bf2025_sinif_12_kfW0tmUYXFdKeftbLfLc",
        "bf2025_sinif_12_eq_t8VrecQCmWdqJmljMFbs",
      ],
    },
  },
  tf_2425: {
    season_name: "tf_2425",
    exam_ids: {
      1: [
        "tf2025_sinif_1_wzB8oE0GO1QHo1hLd74r",
        "tf2025_sinif_1_eq_sLwyQlTZaVjVZsBMjma5",
      ],
      2: [
        "tf2025_sinif_2_d6blfxwXBqKSf4bzOFgC",
        "tf2025_sinif_2_eq_QvFn858OYklvreTZdapl",
      ],
      3: [
        "tf2025_sinif_3_KaqPwEny8ILWnHbczwCh",
        "tf2025_sinif_3_eq_pvdkKPSEFckABHvL2X5S",
      ],
      4: [
        "tf2025_sinif_4_rhQ9koh4EqwJp4Oupnqf",
        "tf2025_sinif_4_eq_N3wEdlaRrVAB6WvyK2Dz",
      ],
      5: [
        "tf2025_sinif_5_ehlJCwQAekV8r49afQmB",
        "tf2025_sinif_5_eq_pRjqu0mUds0wILhJ0Wqk",
      ],
      6: [
        "tf2025_sinif_6_LxR0prE6R3COWCaHsR5g",
        "tf2025_sinif_6_eq_oIFyhc1uWEyrUwdslpGV",
      ],
      7: [
        "tf2025_sinif_7_vSq87hPqTd9UQcetRkwq",
        "tf2025_sinif_7_eq_M1oR7t8JtP48YEvBL8Ul",
      ],
      8: [
        "tf2025_sinif_8_fPCkXeoUjcDcnrMvQCeV",
        "tf2025_sinif_8_eq_rZHwemlbAXpyHsVWoDVn",
      ],
      9: [
        "tf2025_sinif_9_SnqAcAbxtWjlCgQu16Rn",
        "tf2025_sinif_9_eq_cexGCD1t8UzwEKNMqOwb",
      ],
      10: [
        "tf2025_sinif_10_9IZUxgPWm98vMx1kmZy6",
        "tf2025_sinif_10_eq_kLAGXNGEolquVP9pauKc",
      ],
      11: [
        "tf2025_sinif_11_HaqgKZiWb6M1ZymlfWce",
        "tf2025_sinif_11_eq_oMFyS1rmGQPzwrht78Gb",
      ],
      12: [
        "tf2025_sinif_12_oKe0gMUoXggjEtDOAZfLw",
        "tf2025_sinif_12_eq_jmnrfrOBmLdqjmLjWwkp",
      ],
    },
  },

  dnm_2026: {
    season_name: "dnm_2026",
    exam_ids: {
      1: [
        "dnm2026_sinif_1_szB4oE0bO1QHm1hLd75f",
        "dnm2026_sinif_1_eq_DLwyqlTZacjVZsBMJmd4",
      ],
      2: [
        "dnm2026_sinif_2_w6blfcgXBqKSf4bzOhjK",
        "dnm2026_sinif_2_eq_kvFngt8OYklvre7qd2sj",
      ],
      3: [
        "dnm2026_sinif_3_QaqPwkny8ILWpHbczwDx",
        "dnm2026_sinif_3_eq_bvdkKxCEackAhHvL2XpU",
      ],
      4: [
        "dnm2026_sinif_4_vhq1ko3eEqwJp4OuMnVB",
        "dnm2026_sinif_4_eq_t3wEdlaRwVAB32vyK2Fz",
      ],
      5: [
        "dnm2026_sinif_5_NhlJCwQAekVAd49afQbL",
        "dnm2026_sinif_5_eq_NRjwu0DUds0wIshJ03Re",
      ],
      6: [
        "dnm2026_sinif_6_zxR0pr36R3BhWCaHsRhY",
        "dnm2026_sinif_6_eq_LIdyhc1uWvRtUwds2pWq",
      ],
      7: [
        "dnm2026_sinif_7_FSqH8hPqTd5UQcetFLwk",
        "dnm2026_sinif_7_eq_P1oR7t4ThPV8YEvBL8xD",
      ],
      8: [
        "dnm2026_sinif_8_gPCkXwoUJcDcbrMveCeb",
        "dnm2026_sinif_8_eq_lZHweNlbAtpyHsVvo4Vb",
      ],
      9: [
        "dnm2026_sinif_9_unQuWc2bxtWjldgQu1gYu",
        "dnm2026_sinif_9_eq_ceZGsD1t3UzwEsNMqOhM",
      ],
      10: [
        "dnm2026_sinif_10_JfUxgPWm23vNv1kmZq9",
        "dnm2026_sinif_10_eq_hLAGcNGEFdquVP4pa2we",
      ],
      11: [
        "dnm2026_sinif_11_CaWgKZixb6M1ZymkfsX7",
        "dnm2026_sinif_11_eq_yMFyS1TmGdPzQrht58er",
      ],
      12: [
        "dnm2026_sinif_12_uKe0gLUoXwwjEtDOAZfsg",
        "dnm2026_sinif_12_eq_cEnrNr6FmLdqKmLjWwSc",
      ],
    },
  },

  tb_2526: {
    season_name: "tb_2526",
    exam_ids: {
      1: [
        "tb2026_sinif_1_nzE6p9Tku1OjP8hssA8t",
        "tb2026_sinif_1_eq_wl4yLl3wBqJcxsBNpm5f",
      ],
      2: [
        "tb2026_sinif_2_e88qjblcd27kf4uv0hgt",
        "tb2026_sinif_2_eq_hwEC57XoYGhlqeWyXvWh",
      ],
      3: [
        "tb2026_sinif_3_bcrwsgZYwIPeYfMcZbws",
        "tb2026_sinif_3_eq_l4DuFNSpFekSBXQDfCjv",
      ],
      4: [
        "tb2026_sinif_4_utqoKo39v6Gkl4zurezt",
        "tb2026_sinif_4_eq_e3QsdLAEex33wLrbLw7Nl",
      ],
      5: [
        "tb2026_sinif_5_yhleCmbArLV7Rx7aWL0t",
        "tb2026_sinif_5_eq_GZekWexMjvFGqeYAl8vd",
      ],
      6: [
        "tb2026_sinif_6_rLtplEj6q3WRsva7Dpew",
        "tb2026_sinif_6_eq_wlbPhcl8eEFWUcDsLpyt",
      ],
      7: [
        "tb2026_sinif_7_exSq5eTYqfE5QvGtBy7x",
        "tb2026_sinif_7_eq_a4Ksot8HYh4uYxvb55rQ",
      ],
      8: [
        "tb2026_sinif_8_d2lcU1xpWx4etEoLwCfl",
        "tb2026_sinif_8_eq_vYxhEJe4keaLThSncOck",
      ],
      9: [
        "tb2026_sinif_9_bVewcAweRrjlngqk43th",
        "tb2026_sinif_9_eq_cEBcgf2E1o5wxBh5dQoxs",
      ],
      10: [
        "tb2026_sinif_10_tIEuwDgbTx4pok1glTsp",
        "tb2026_sinif_10_eq_rgbN5lk6edY3EpZBaUBx",
      ],
      11: [
        "tb2026_sinif_11_op6OKZrJlEy9tn8NbfQx",
        "tb2026_sinif_11_eq_cbJ8Me4mq0Za6kt5h5w",
      ],
      12: [
        "tb2026_sinif_12_zfWvtmUYrFSKefRb5fLk",
        "tb2026_sinif_12_eq_y8RreCQ5m67WJylj6Fgs",
      ],
    },
  },

  //  İL FİNALLERİ SINAVI LİNKLERİ

  if_2526: {
    season_name: "if_2526",
    exam_ids: {
      1: [
        "if2026_sinif_1_czw6p9Tvq1OjP8LssAwa",
        "if2026_sinif_1_eq_vl2yL43wBqJLxABnpK5W",
      ],
      2: [
        "if2026_sinif_2_s85qjbNcdq7kY4Vv9hgZ",
        "if2026_sinif_2_eq_lwEc576Q6GhlqWLyXvqk",
      ],
      3: [
        "if2026_sinif_3_zcWr9gZYwIRe8fMcZ6wV",
        "if2026_sinif_3_eq_m4FudNSpF9kSBXxDwCqc",
      ],
      4: [
        "if2026_sinif_4_btqZKo3Wv6GL34XuTeFm",
        "if2026_sinif_4_eq_f3QwdLAhex43wLrlLTvNx",
      ],
      5: [
        "if2026_sinif_5_nhlwCmb4rLV7Rp7sWL3a",
        "if2026_sinif_5_eq_vZekNeAKjvLGQeYalRv4",
      ],
      6: [
        "if2026_sinif_6_eLtpNbj6q4W4sCa7sUe6",
        "if2026_sinif_6_eq_ElbPmcl3e5FSUcBsLOyg",
      ],
      7: [
        "if2026_sinif_7_yZSq5ehY4fE5jvGt5U7E",
        "if2026_sinif_7_eq_r4KsoX8fYh4YZxvb35re",
      ],
      8: [
        "if2026_sinif_8_l2HxU9xpQx4e7EULwCfS",
        "if2026_sinif_8_eq_vYxhEqe3kQaL5KSnbOcL",
      ],
      9: [
        "if2026_sinif_9_kV4wEAw9RrLlnDWke3ts",
        "if2026_sinif_9_eq_UEzcgf88fo5wDch5dQExy",
      ],
      10: [
        "if2026_sinif_10_HIt7wDUbTx4QoD1g6Ts0",
        "if2026_sinif_10_eq_tqbNplD6edtPEpZBaUBr",
      ],
      11: [
        "if2026_sinif_11_Vp2OKZsJlyD94n8jbf5t",
        "if2026_sinif_11_eq_zbJ8Ve4Xq0pSokt7h5v",
      ],
      12: [
        "if2026_sinif_12_kf4tDmbYEFwKgfR4QfLc",
        "if2026_sinif_12_eq_s0RreCr5mC3QJylj6mgt",
      ],
    },
  },

  // BÖLGE FİNALLERİ SINAVI LİNKLERİ
  bf_2526: {
    season_name: "bf_2526",
    exam_ids: {
      1: [
        "bf2026_sinif_1_b7r8o91Gp1PHo1hsdy4L",
        "bf2026_sinif_1_eq_7lEyllTwaVlgZDBNjmLp",
      ],
      2: [
        "bf2026_sinif_2_s6bifxSXBplSf4Qz5hgk",
        "bf2026_sinif_2_eq_8vFnO58uYkl05TtydbI3",
      ],
      3: [
        "bf2026_sinif_3_5ZqPsECpGIPWNObxzECo",
        "bf2026_sinif_3_eq_5pFbjPS8FOkTBdvk2C88",
      ],
      4: [
        "bf2026_sinif_4_O7QOk5h4EpwJp4OdsMMK",
        "bf2026_sinif_4_eq_d3wb6lasrxBA6rvpM6Ze",
      ],
      5: [
        "bf2026_sinif_5_GhpsJCAQAeKV8R46aQQ0p",
        "bf2026_sinif_5_eq_1dRj9u7NUd80qOkDJ0vs",
      ],
      6: [
        "bf2026_sinif_6_5xt08rF6R3wOlCa8sp99",
        "bf2026_sinif_6_eq_hIF8R7l5zE4rUXdeKphH",
      ],
      7: [
        "bf2026_sinif_7_cSq17TPqTS9OAQcGtRGwL",
        "bf2026_sinif_7_eq_B1of7t8YtP46YAvAy7Uq",
      ],
      8: [
        "bf2026_sinif_8_dPCLXKOWpjxDcYrovQCia",
        "bf2026_sinif_8_eq_F5THwKel9e6py7smXoac",
      ],
      9: [
        "bf2026_sinif_9_knqacAbBs8WjiCgQ516TP",
        "bf2026_sinif_9_eq_AHxeC51t1UzwCK6Mqokf",
      ],
      10: [
        "bf2026_sinif_10_0Ifr9xgPAm94UMc1kxKs5",
        "bf2026_sinif_10_eq_5FAoz4G3olq7VPZ8auks",
      ],
      11: [
        "bf2026_sinif_11_Ya9gK9iwlmv8XM6mjfqB",
        "bf2026_sinif_11_eq_PMF6t1rgVxPUarnt72ox",
      ],
      12: [
        "bf2026_sinif_12_8KR0gOKUoXjjdtfOblfLq",
        "bf2026_sinif_12_eq_7mRrGeOmCtdQj8lm9XbK",
      ],
    },
  },

  tf_2526: {
  season_name: "tf_2526",
  exam_ids: {
    1: [
      "tf2026_sinif_1_mK9xPqR2vNwLjT5hYcBd",
      "tf2026_sinif_1_eq_Tz8mRnQvXwBjLcYoHpAe",
    ],
    2: [
      "tf2026_sinif_2_Hn7sZoE4uFbXgA1kWmQp",
      "tf2026_sinif_2_eq_Nd4sKfUiGrEbWoZxMqCv",
    ],
    3: [
      "tf2026_sinif_3_Cv3rJyU8tDiMlS6nOePf",
      "tf2026_sinif_3_eq_Jh7pOyT2mVcLsAiXnRwB",
    ],
    4: [
      "tf2026_sinif_4_Bw5qIaG0xKhRzV2eTdLn",
      "tf2026_sinif_4_eq_Wq5rEzH9kDnMfUbYcTxS",
    ],
    5: [
      "tf2026_sinif_5_Px4mYcF7vNjWsA9uHoQk",
      "tf2026_sinif_5_eq_Lc3vBsN6tRjPoQwAiZmG",
    ],
    6: [
      "tf2026_sinif_6_Td8nEbZ3rMgKwL1iXuCo",
      "tf2026_sinif_6_eq_Xo1nYhK4uFgMdTrEbWqs",
    ],
    7: [
      "tf2026_sinif_7_Qf2oRvH5yJsNpB6mWxAe",
      "tf2026_sinif_7_eq_Av6mCwJ8zLpRiHoNqXeT",
    ],
    8: [
      "tf2026_sinif_8_Lk6tUwD9cIzGrE3nFjMs",
      "tf2026_sinif_8_eq_Gf2tSoD5yNkWxBjMvUcR",
    ],
    9: [
      "tf2026_sinif_9_Aw1pSxK4hObYvN7qTmZr",
      "tf2026_sinif_9_eq_Ib9qZeA3hPmYsLwCnTjO",
    ],
    10: [
      "tf2026_sinif_10_Jn3uFcL8mRiQdX5oBwEy",
      "tf2026_sinif_10_eq_Hm4wVuR7cXoGbNaTzEpL",
    ],
    11: [
      "tf2026_sinif_11_Gy7vTzA2kWsPoH4xNjCb",
      "tf2026_sinif_11_eq_Ek8nMiB1vJdYqFsWzOrC",
    ],
    12: [
      "tf2026_sinif_12_Rs5hOeB6nYmUcJ3wLqVi",
      "tf2026_sinif_12_eq_Fp6oTjG4rNwHcBmXuLiS",
    ],
  },
},

};
